import { render, staticRenderFns } from "./Solicita.vue?vue&type=template&id=02bd815e&scoped=true"
import script from "./Solicita.vue?vue&type=script&lang=js"
export * from "./Solicita.vue?vue&type=script&lang=js"
import style0 from "./Solicita.vue?vue&type=style&index=0&id=02bd815e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bd815e",
  null
  
)

export default component.exports